import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { UpdateInteractionStateTrackingCommand, UpdateInteractionStateTrackingCommandPayload } from '../api';
import { InteractionSuspendDataStore2 } from '../common';

@injectable()
export class Scorm2004UpdateInteractionStateCommandHandler implements CommandHandler<UpdateInteractionStateTrackingCommand> {

  constructor(
    @inject(InteractionSuspendDataStore2)
    private suspendDataStore: InteractionSuspendDataStore2,
) {
  }

  public async execute(command: UpdateInteractionStateTrackingCommandPayload) {

    await this.suspendDataStore.execute(
      createCommand<UpdateInteractionStateTrackingCommand>('update-interaction-state', command))
  }
}
